import { SupportUserAvailabilityOverride } from "@redotech/crdb-enums/support-v2/support-user-availability-override";
import type { SetUserAvailabilityAction as SetUserAvailabilityActionType } from "@redotech/redo-flows-common/rules/schemas";
import { t, useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

type AvailabilityOption = SupportUserAvailabilityOverride | "clear";

const availabilityOptions = (): RedoListItem<AvailabilityOption>[] => [
  {
    id: SupportUserAvailabilityOverride.Active,
    type: "text",
    text: t("Available"),
    value: SupportUserAvailabilityOverride.Active,
  },
  {
    id: SupportUserAvailabilityOverride.Inactive,
    type: "text",
    text: t("Unavailable"),
    value: SupportUserAvailabilityOverride.Inactive,
  },
  {
    id: "clear",
    type: "text",
    text: t("Follow their schedule (clear)"),
    value: "clear",
  },
];

export const SetUserAvailabilityAction = memo(
  function SetUserAvailabilityAction({
    action,
    onChange,
    editableFields,
  }: {
    action: SetUserAvailabilityActionType;
    onChange: (updated: SetUserAvailabilityActionType) => void;
    editableFields?: ReadonlySet<string>;
  }) {
    const { t } = useTranslation();
    const statusEditable =
      editableFields === undefined || editableFields.has("status");

    const selected = useMemo(() => {
      const value: AvailabilityOption = action.status ?? "clear";
      return availabilityOptions().find((opt) => opt.value === value);
    }, [action.status]);

    return (
      <Flex dir="column" gap="md" w="full">
        <RedoSingleSelectDropdownInput<AvailabilityOption>
          disabled={!statusEditable}
          fitToAnchor
          label={t("Set the teammate to")}
          options={availabilityOptions()}
          optionSelected={({ item }) => {
            if (!statusEditable) {
              return;
            }
            onChange({
              ...action,
              status: item.value === "clear" ? null : item.value,
            });
          }}
          selectedItem={selected}
        />
      </Flex>
    );
  },
);
